import Vue from 'vue'

export const notes = {
    namespaced: true,
    state: {
        notes: [],
        open: false
    },
    actions: {
        addNote({ commit }, note) {
            commit('add', note);
        },
        setNote({ commit }, note) {
            commit('update', note);
        },
        deleteNote({ commit }, noteId) {
            commit('delete', noteId);
        },
        toggleNotes({ commit }) {
            commit('toggle');
        }
    },
    mutations: {
        add(state, note) {
            Vue.set(state, 'notes', [...state.notes, note]);
        },
        update(state, note) {
            let index = state.notes.findIndex(n => n.id === note.id);
            if (index > -1) {
                state.notes[index] = note;
                Vue.set(state, 'notes', state.notes);
            }
        },
        delete(state, noteId) {
            let notes = state.notes.filter(n => n.id !== noteId);
            Vue.set(state, 'notes', notes);
        },
        toggle(state) {
            Vue.set(state, 'open', !state.open);
        }
    },
    getters: {
        getNotes: state => state.notes,
        getNote: state => noteId => state.notes.find(n => n.id === noteId),
        isOpenedNotes: state => state.open
    }
}